<mat-toolbar class="header">
  <div class="back" mat-dialog-close matTooltip="Atrás" matTooltipPosition="right">
    <mat-icon >arrow_back_ios_new</mat-icon>
  </div>
  <div>
    Crear Cliente
  </div>
</mat-toolbar>

<div class="dialog-wrapper">
  <div #wrapper>
    <app-client-form
      [parentFormGroup]="form"
      [showRating]="true"
      [enableRating]="true"
    >
    </app-client-form>
  </div>
</div>

<mat-toolbar class="footer">
  <button mat-raised-button mat-dialog-close> 
    Cancelar
  </button>
  <div class="expander"></div>
  <button type="button" [disabled]="!form.valid" mat-raised-button (click)="createClient()">Crear</button>
</mat-toolbar>
